
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as activity_45endZpLgWp1eeMMeta } from "/app/pages/activity-end.vue?macro=true";
import { default as black_45friday_452024kAxA772Zg7Meta } from "/app/pages/activity/black-friday-2024.vue?macro=true";
import { default as christmasnJUt4GDrumMeta } from "/app/pages/activity/christmas.vue?macro=true";
import { default as compensationOIZD9zgNxSMeta } from "/app/pages/activity/compensation.vue?macro=true";
import { default as auth_45success4k5L2uHFOQMeta } from "/app/pages/auth-success.vue?macro=true";
import { default as auth7tE1sZcZDUMeta } from "/app/pages/auth.vue?macro=true";
import { default as browser_45extensionME0iem529IMeta } from "/app/pages/browser-extension.vue?macro=true";
import { default as check_45in_45guides6H00YldiZMeta } from "/app/pages/check-in-guide.vue?macro=true";
import { default as check_45inqjWKIVB6LkMeta } from "/app/pages/check-in.vue?macro=true";
import { default as contact_45uszp1HYnA7MsMeta } from "/app/pages/contact-us.vue?macro=true";
import { default as desktop_45app3GWmWATZhUMeta } from "/app/pages/desktop-app.vue?macro=true";
import { default as faqIMkmXQpKKaMeta } from "/app/pages/faq.vue?macro=true";
import { default as favorite_45links_45hub5gwaTAP7CFMeta } from "/app/pages/favorite-links-hub.vue?macro=true";
import { default as _91_46_46_46slug_933TGRA5pZavMeta } from "/app/pages/help-center/[...slug].vue?macro=true";
import { default as indexNgHTocZnJHMeta } from "/app/pages/help-center/index.vue?macro=true";
import { default as helpgX3yoxbmc4Meta } from "/app/pages/help.vue?macro=true";
import { default as shopGOCMYA8NnkMeta } from "/app/pages/inapp/shop.vue?macro=true";
import { default as widget8LKCcyFMVuMeta } from "/app/pages/inapp/widget.vue?macro=true";
import { default as install_45apk_45troubleshooting8wTafiMAdaMeta } from "/app/pages/install-apk-troubleshooting.vue?macro=true";
import { default as loadingvUSIcl4zTFMeta } from "/app/pages/loading.vue?macro=true";
import { default as mobile_45appIJUBn0DzbHMeta } from "/app/pages/mobile-app.vue?macro=true";
import { default as anti_45abuseI6QT3240VFMeta } from "/app/pages/policy/anti-abuse/anti-abuse.vue?macro=true";
import { default as index9JarGFMp5WMeta } from "/app/pages/policy/anti-abuse/index.vue?macro=true";
import { default as _2023_4505_4523WF8kncENBUMeta } from "/app/pages/policy/child-sexual-abuse/2023-05-23.vue?macro=true";
import { default as _2025_4502_4512LikzzFKQQlMeta } from "/app/pages/policy/child-sexual-abuse/2025-02-12.vue?macro=true";
import { default as indexe8ZyK2GaTKMeta } from "/app/pages/policy/child-sexual-abuse/index.vue?macro=true";
import { default as copyright_45InfringementEVTC0Oe05BMeta } from "/app/pages/policy/copyright-Infringement/copyright-Infringement.vue?macro=true";
import { default as indexnjQ3za1MCGMeta } from "/app/pages/policy/copyright-Infringement/index.vue?macro=true";
import { default as _2022_4506_45141QlRDJzZ0hMeta } from "/app/pages/policy/membership-agreement/2022-06-14.vue?macro=true";
import { default as _2023_4508_4523hAXM76P9AVMeta } from "/app/pages/policy/membership-agreement/2023-08-23.vue?macro=true";
import { default as indexiwRhMI5Rw8Meta } from "/app/pages/policy/membership-agreement/index.vue?macro=true";
import { default as _2021_4511_4508z8tZNLxuvKMeta } from "/app/pages/policy/privacy-policy/2021-11-08.vue?macro=true";
import { default as _2023_4510_4514RIfyr1g6hWMeta } from "/app/pages/policy/privacy-policy/2023-10-14.vue?macro=true";
import { default as _2023_4511_4506FrqN5oxUJ1Meta } from "/app/pages/policy/privacy-policy/2023-11-06.vue?macro=true";
import { default as indexSLlQIy1Tl5Meta } from "/app/pages/policy/privacy-policy/index.vue?macro=true";
import { default as _2025_4502_4512dsJH3FJsFAMeta } from "/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue?macro=true";
import { default as indexjZXpkzdnS7Meta } from "/app/pages/policy/update/index.vue?macro=true";
import { default as _2023_4508_4523gWMOOnsPDZMeta } from "/app/pages/policy/update/membership-agreement/2023-08-23.vue?macro=true";
import { default as _2023_4510_45148tgBBMrS1bMeta } from "/app/pages/policy/update/privacy-policy/2023-10-14.vue?macro=true";
import { default as _2023_4511_4506FxN9s9QRMYMeta } from "/app/pages/policy/update/privacy-policy/2023-11-06.vue?macro=true";
import { default as index0dPUWU2A2DMeta } from "/app/pages/policy/user-agreement/index.vue?macro=true";
import { default as user_45agreementg1YWmpcZZtMeta } from "/app/pages/policy/user-agreement/user-agreement.vue?macro=true";
import { default as _91_46_46_46parent_ids_93HxGPrChXC1Meta } from "/app/pages/s/[share_id]/[...parent_ids].vue?macro=true";
import { default as _91share_id_93vsciUONaNIMeta } from "/app/pages/s/[share_id].vue?macro=true";
import { default as testL3AVDvhyXeMeta } from "/app/pages/test.vue?macro=true";
import { default as tv_45help1Vj3zH5UghMeta } from "/app/pages/tv-help.vue?macro=true";
import { default as tv80s8GJMkwnMeta } from "/app/pages/tv.vue?macro=true";
import { default as unsubscribeuH6r0XUkMkMeta } from "/app/pages/unsubscribe.vue?macro=true";
import { default as component_45stubnO9MU04yTUMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubnO9MU04yTU } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "activity-end___en-US",
    path: "/en-US/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___es",
    path: "/es/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___id",
    path: "/id/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___ja",
    path: "/ja/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___ko",
    path: "/ko/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___ms",
    path: "/ms/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___pt",
    path: "/pt/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___ru",
    path: "/ru/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___uk",
    path: "/uk/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___zh-CN",
    path: "/zh-CN/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___zh-TW",
    path: "/zh-TW/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "black-friday___en-US",
    path: "/en-US/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___es",
    path: "/es/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___id",
    path: "/id/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___ja",
    path: "/ja/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___ko",
    path: "/ko/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___ms",
    path: "/ms/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___pt",
    path: "/pt/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___ru",
    path: "/ru/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___uk",
    path: "/uk/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___zh-CN",
    path: "/zh-CN/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___zh-TW",
    path: "/zh-TW/activity/black-friday",
    meta: black_45friday_452024kAxA772Zg7Meta || {},
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "activity-christmas___en-US",
    path: "/en-US/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___es",
    path: "/es/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___id",
    path: "/id/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___ja",
    path: "/ja/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___ko",
    path: "/ko/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___ms",
    path: "/ms/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___pt",
    path: "/pt/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___ru",
    path: "/ru/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___uk",
    path: "/uk/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___zh-CN",
    path: "/zh-CN/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___zh-TW",
    path: "/zh-TW/activity/christmas",
    meta: christmasnJUt4GDrumMeta || {},
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-compensation___en-US",
    path: "/en-US/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___es",
    path: "/es/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___id",
    path: "/id/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___ja",
    path: "/ja/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___ko",
    path: "/ko/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___ms",
    path: "/ms/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___pt",
    path: "/pt/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___ru",
    path: "/ru/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___uk",
    path: "/uk/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___zh-CN",
    path: "/zh-CN/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___zh-TW",
    path: "/zh-TW/activity/compensation",
    meta: compensationOIZD9zgNxSMeta || {},
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "auth-success___en-US",
    path: "/en-US/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___es",
    path: "/es/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___id",
    path: "/id/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___ja",
    path: "/ja/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___ko",
    path: "/ko/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___ms",
    path: "/ms/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___pt",
    path: "/pt/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___ru",
    path: "/ru/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___uk",
    path: "/uk/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___zh-CN",
    path: "/zh-CN/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___zh-TW",
    path: "/zh-TW/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("/app/pages/auth.vue")
  },
  {
    name: "browser-extension___en-US",
    path: "/en-US/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___es",
    path: "/es/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___id",
    path: "/id/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___ja",
    path: "/ja/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___ko",
    path: "/ko/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___ms",
    path: "/ms/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___pt",
    path: "/pt/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___ru",
    path: "/ru/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___uk",
    path: "/uk/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___zh-CN",
    path: "/zh-CN/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___zh-TW",
    path: "/zh-TW/browser-extension",
    meta: browser_45extensionME0iem529IMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "check-in-guide___en-US",
    path: "/en-US/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___es",
    path: "/es/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___id",
    path: "/id/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___ja",
    path: "/ja/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___ko",
    path: "/ko/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___ms",
    path: "/ms/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___pt",
    path: "/pt/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___ru",
    path: "/ru/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___uk",
    path: "/uk/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___zh-CN",
    path: "/zh-CN/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___zh-TW",
    path: "/zh-TW/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in___en-US",
    path: "/en-US/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___es",
    path: "/es/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___id",
    path: "/id/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___ja",
    path: "/ja/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___ko",
    path: "/ko/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___ms",
    path: "/ms/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___pt",
    path: "/pt/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___ru",
    path: "/ru/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___uk",
    path: "/uk/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___zh-CN",
    path: "/zh-CN/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___zh-TW",
    path: "/zh-TW/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "contact-us___en-US",
    path: "/en-US/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___es",
    path: "/es/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___id",
    path: "/id/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___ja",
    path: "/ja/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___ko",
    path: "/ko/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___ms",
    path: "/ms/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___pt",
    path: "/pt/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___ru",
    path: "/ru/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___uk",
    path: "/uk/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___zh-CN",
    path: "/zh-CN/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___zh-TW",
    path: "/zh-TW/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "desktop-app___en-US",
    path: "/en-US/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___es",
    path: "/es/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___id",
    path: "/id/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___ja",
    path: "/ja/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___ko",
    path: "/ko/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___ms",
    path: "/ms/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___pt",
    path: "/pt/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___ru",
    path: "/ru/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___uk",
    path: "/uk/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___zh-CN",
    path: "/zh-CN/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___zh-TW",
    path: "/zh-TW/desktop-app",
    meta: desktop_45app3GWmWATZhUMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "faq___en-US",
    path: "/en-US/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___id",
    path: "/id/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ja",
    path: "/ja/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ko",
    path: "/ko/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ms",
    path: "/ms/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___pt",
    path: "/pt/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___uk",
    path: "/uk/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___zh-CN",
    path: "/zh-CN/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___zh-TW",
    path: "/zh-TW/faq",
    meta: faqIMkmXQpKKaMeta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "favorite-links-hub___en-US",
    path: "/en-US/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___es",
    path: "/es/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___id",
    path: "/id/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___ja",
    path: "/ja/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___ko",
    path: "/ko/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___ms",
    path: "/ms/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___pt",
    path: "/pt/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___ru",
    path: "/ru/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___uk",
    path: "/uk/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___zh-CN",
    path: "/zh-CN/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___zh-TW",
    path: "/zh-TW/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "help-center-slug___en-US",
    path: "/en-US/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___es",
    path: "/es/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___id",
    path: "/id/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___ja",
    path: "/ja/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___ko",
    path: "/ko/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___ms",
    path: "/ms/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___pt",
    path: "/pt/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___ru",
    path: "/ru/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___uk",
    path: "/uk/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___zh-CN",
    path: "/zh-CN/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___zh-TW",
    path: "/zh-TW/help-center/:slug(.*)*",
    meta: _91_46_46_46slug_933TGRA5pZavMeta || {},
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center___en-US",
    path: "/en-US/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___es",
    path: "/es/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___id",
    path: "/id/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___ja",
    path: "/ja/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___ko",
    path: "/ko/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___ms",
    path: "/ms/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___pt",
    path: "/pt/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___ru",
    path: "/ru/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___uk",
    path: "/uk/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___zh-CN",
    path: "/zh-CN/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___zh-TW",
    path: "/zh-TW/help-center",
    meta: indexNgHTocZnJHMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help___en-US",
    path: "/en-US/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___es",
    path: "/es/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___id",
    path: "/id/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___ja",
    path: "/ja/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___ko",
    path: "/ko/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___ms",
    path: "/ms/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___pt",
    path: "/pt/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___ru",
    path: "/ru/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___uk",
    path: "/uk/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___zh-CN",
    path: "/zh-CN/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___zh-TW",
    path: "/zh-TW/help",
    meta: helpgX3yoxbmc4Meta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "inapp-shop___en-US",
    path: "/en-US/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___es",
    path: "/es/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___id",
    path: "/id/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___ja",
    path: "/ja/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___ko",
    path: "/ko/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___ms",
    path: "/ms/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___pt",
    path: "/pt/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___ru",
    path: "/ru/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___uk",
    path: "/uk/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___zh-CN",
    path: "/zh-CN/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___zh-TW",
    path: "/zh-TW/inapp/shop",
    meta: shopGOCMYA8NnkMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-widget___en-US",
    path: "/en-US/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___es",
    path: "/es/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___id",
    path: "/id/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___ja",
    path: "/ja/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___ko",
    path: "/ko/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___ms",
    path: "/ms/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___pt",
    path: "/pt/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___ru",
    path: "/ru/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___uk",
    path: "/uk/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___zh-CN",
    path: "/zh-CN/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___zh-TW",
    path: "/zh-TW/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "index___en-US",
    path: "/en-US",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ms",
    path: "/ms",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___zh-CN",
    path: "/zh-CN",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___zh-TW",
    path: "/zh-TW",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "install-apk-troubleshooting___en-US",
    path: "/en-US/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___es",
    path: "/es/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___id",
    path: "/id/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___ja",
    path: "/ja/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___ko",
    path: "/ko/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___ms",
    path: "/ms/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___pt",
    path: "/pt/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___ru",
    path: "/ru/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___uk",
    path: "/uk/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___zh-CN",
    path: "/zh-CN/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___zh-TW",
    path: "/zh-TW/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "loading",
    path: "/loading",
    component: () => import("/app/pages/loading.vue")
  },
  {
    name: "mobile-app___en-US",
    path: "/en-US/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___es",
    path: "/es/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___id",
    path: "/id/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ja",
    path: "/ja/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ko",
    path: "/ko/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ms",
    path: "/ms/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___pt",
    path: "/pt/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ru",
    path: "/ru/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___uk",
    path: "/uk/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___zh-CN",
    path: "/zh-CN/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___zh-TW",
    path: "/zh-TW/mobile-app",
    meta: mobile_45appIJUBn0DzbHMeta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___en-US",
    path: "/en-US/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___es",
    path: "/es/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___id",
    path: "/id/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___ja",
    path: "/ja/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___ko",
    path: "/ko/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___ms",
    path: "/ms/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___pt",
    path: "/pt/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___ru",
    path: "/ru/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___uk",
    path: "/uk/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___zh-CN",
    path: "/zh-CN/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse-anti-abuse___zh-TW",
    path: "/zh-TW/policy/anti-abuse/anti-abuse",
    meta: anti_45abuseI6QT3240VFMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/anti-abuse.vue")
  },
  {
    name: "policy-anti-abuse___en-US",
    path: "/en-US/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___es",
    path: "/es/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___id",
    path: "/id/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___ja",
    path: "/ja/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___ko",
    path: "/ko/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___ms",
    path: "/ms/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___pt",
    path: "/pt/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___ru",
    path: "/ru/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___uk",
    path: "/uk/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___zh-CN",
    path: "/zh-CN/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___zh-TW",
    path: "/zh-TW/policy/anti-abuse",
    meta: index9JarGFMp5WMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___en-US",
    path: "/en-US/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___es",
    path: "/es/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___id",
    path: "/id/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___ja",
    path: "/ja/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___ko",
    path: "/ko/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___ms",
    path: "/ms/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___pt",
    path: "/pt/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___ru",
    path: "/ru/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___uk",
    path: "/uk/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___zh-CN",
    path: "/zh-CN/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___zh-TW",
    path: "/zh-TW/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523WF8kncENBUMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___en-US",
    path: "/en-US/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___es",
    path: "/es/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___id",
    path: "/id/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___ja",
    path: "/ja/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___ko",
    path: "/ko/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___ms",
    path: "/ms/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___pt",
    path: "/pt/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___ru",
    path: "/ru/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___uk",
    path: "/uk/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___zh-CN",
    path: "/zh-CN/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___zh-TW",
    path: "/zh-TW/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512LikzzFKQQlMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse___en-US",
    path: "/en-US/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___es",
    path: "/es/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___id",
    path: "/id/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___ja",
    path: "/ja/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___ko",
    path: "/ko/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___ms",
    path: "/ms/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___pt",
    path: "/pt/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___ru",
    path: "/ru/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___uk",
    path: "/uk/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___zh-CN",
    path: "/zh-CN/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___zh-TW",
    path: "/zh-TW/policy/child-sexual-abuse",
    meta: indexe8ZyK2GaTKMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___en-US",
    path: "/en-US/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___es",
    path: "/es/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___id",
    path: "/id/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___ja",
    path: "/ja/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___ko",
    path: "/ko/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___ms",
    path: "/ms/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___pt",
    path: "/pt/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___ru",
    path: "/ru/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___uk",
    path: "/uk/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___zh-CN",
    path: "/zh-CN/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___zh-TW",
    path: "/zh-TW/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementEVTC0Oe05BMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement___en-US",
    path: "/en-US/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___es",
    path: "/es/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___id",
    path: "/id/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___ja",
    path: "/ja/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___ko",
    path: "/ko/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___ms",
    path: "/ms/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___pt",
    path: "/pt/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___ru",
    path: "/ru/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___uk",
    path: "/uk/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___zh-CN",
    path: "/zh-CN/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___zh-TW",
    path: "/zh-TW/policy/copyright-Infringement",
    meta: indexnjQ3za1MCGMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___en-US",
    path: "/en-US/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___es",
    path: "/es/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___id",
    path: "/id/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___ja",
    path: "/ja/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___ko",
    path: "/ko/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___ms",
    path: "/ms/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___pt",
    path: "/pt/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___ru",
    path: "/ru/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___uk",
    path: "/uk/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___zh-CN",
    path: "/zh-CN/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___zh-TW",
    path: "/zh-TW/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_45141QlRDJzZ0hMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___en-US",
    path: "/en-US/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___es",
    path: "/es/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___id",
    path: "/id/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___ja",
    path: "/ja/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___ko",
    path: "/ko/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___ms",
    path: "/ms/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___pt",
    path: "/pt/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___ru",
    path: "/ru/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___uk",
    path: "/uk/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___zh-CN",
    path: "/zh-CN/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___zh-TW",
    path: "/zh-TW/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523hAXM76P9AVMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement___en-US",
    path: "/en-US/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___es",
    path: "/es/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___id",
    path: "/id/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___ja",
    path: "/ja/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___ko",
    path: "/ko/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___ms",
    path: "/ms/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___pt",
    path: "/pt/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___ru",
    path: "/ru/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___uk",
    path: "/uk/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___zh-CN",
    path: "/zh-CN/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___zh-TW",
    path: "/zh-TW/policy/membership-agreement",
    meta: indexiwRhMI5Rw8Meta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___en-US",
    path: "/en-US/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___es",
    path: "/es/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___id",
    path: "/id/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___ja",
    path: "/ja/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___ko",
    path: "/ko/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___ms",
    path: "/ms/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___pt",
    path: "/pt/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___ru",
    path: "/ru/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___uk",
    path: "/uk/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___zh-CN",
    path: "/zh-CN/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___zh-TW",
    path: "/zh-TW/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508z8tZNLxuvKMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___en-US",
    path: "/en-US/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___es",
    path: "/es/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___id",
    path: "/id/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___ja",
    path: "/ja/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___ko",
    path: "/ko/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___ms",
    path: "/ms/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___pt",
    path: "/pt/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___ru",
    path: "/ru/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___uk",
    path: "/uk/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___zh-CN",
    path: "/zh-CN/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___zh-TW",
    path: "/zh-TW/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514RIfyr1g6hWMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___en-US",
    path: "/en-US/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___es",
    path: "/es/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___id",
    path: "/id/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___ja",
    path: "/ja/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___ko",
    path: "/ko/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___ms",
    path: "/ms/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___pt",
    path: "/pt/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___ru",
    path: "/ru/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___uk",
    path: "/uk/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___zh-CN",
    path: "/zh-CN/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___zh-TW",
    path: "/zh-TW/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FrqN5oxUJ1Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy___en-US",
    path: "/en-US/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___es",
    path: "/es/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___id",
    path: "/id/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___ja",
    path: "/ja/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___ko",
    path: "/ko/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___ms",
    path: "/ms/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___pt",
    path: "/pt/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___ru",
    path: "/ru/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___uk",
    path: "/uk/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___zh-CN",
    path: "/zh-CN/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___zh-TW",
    path: "/zh-TW/policy/privacy-policy",
    meta: indexSLlQIy1Tl5Meta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___en-US",
    path: "/en-US/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___es",
    path: "/es/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___id",
    path: "/id/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___ja",
    path: "/ja/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___ko",
    path: "/ko/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___ms",
    path: "/ms/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___pt",
    path: "/pt/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___ru",
    path: "/ru/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___uk",
    path: "/uk/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___zh-CN",
    path: "/zh-CN/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___zh-TW",
    path: "/zh-TW/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512dsJH3FJsFAMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update___en-US",
    path: "/en-US/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___es",
    path: "/es/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___id",
    path: "/id/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___ja",
    path: "/ja/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___ko",
    path: "/ko/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___ms",
    path: "/ms/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___pt",
    path: "/pt/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___ru",
    path: "/ru/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___uk",
    path: "/uk/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___zh-CN",
    path: "/zh-CN/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___zh-TW",
    path: "/zh-TW/policy/update",
    meta: indexjZXpkzdnS7Meta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___en-US",
    path: "/en-US/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___es",
    path: "/es/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___id",
    path: "/id/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___ja",
    path: "/ja/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___ko",
    path: "/ko/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___ms",
    path: "/ms/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___pt",
    path: "/pt/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___ru",
    path: "/ru/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___uk",
    path: "/uk/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___zh-CN",
    path: "/zh-CN/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___zh-TW",
    path: "/zh-TW/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_4523gWMOOnsPDZMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___en-US",
    path: "/en-US/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___es",
    path: "/es/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___id",
    path: "/id/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___ja",
    path: "/ja/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___ko",
    path: "/ko/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___ms",
    path: "/ms/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___pt",
    path: "/pt/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___ru",
    path: "/ru/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___uk",
    path: "/uk/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___zh-CN",
    path: "/zh-CN/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___zh-TW",
    path: "/zh-TW/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_45148tgBBMrS1bMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___en-US",
    path: "/en-US/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___es",
    path: "/es/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___id",
    path: "/id/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___ja",
    path: "/ja/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___ko",
    path: "/ko/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___ms",
    path: "/ms/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___pt",
    path: "/pt/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___ru",
    path: "/ru/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___uk",
    path: "/uk/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___zh-CN",
    path: "/zh-CN/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___zh-TW",
    path: "/zh-TW/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_4506FxN9s9QRMYMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-user-agreement___en-US",
    path: "/en-US/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___es",
    path: "/es/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___id",
    path: "/id/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___ja",
    path: "/ja/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___ko",
    path: "/ko/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___ms",
    path: "/ms/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___pt",
    path: "/pt/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___ru",
    path: "/ru/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___uk",
    path: "/uk/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___zh-CN",
    path: "/zh-CN/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___zh-TW",
    path: "/zh-TW/policy/user-agreement",
    meta: index0dPUWU2A2DMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___en-US",
    path: "/en-US/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___es",
    path: "/es/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___id",
    path: "/id/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___ja",
    path: "/ja/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___ko",
    path: "/ko/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___ms",
    path: "/ms/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___pt",
    path: "/pt/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___ru",
    path: "/ru/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___uk",
    path: "/uk/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___zh-CN",
    path: "/zh-CN/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___zh-TW",
    path: "/zh-TW/policy/user-agreement/user-agreement",
    meta: user_45agreementg1YWmpcZZtMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "s-share_id",
    path: "/s/:share_id()",
    meta: _91share_id_93vsciUONaNIMeta || {},
    component: () => import("/app/pages/s/[share_id].vue"),
    children: [
  {
    name: "s-share_id-parent_ids",
    path: ":parent_ids(.*)*",
    component: () => import("/app/pages/s/[share_id]/[...parent_ids].vue")
  }
]
  },
  {
    name: "test___en-US",
    path: "/en-US/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___es",
    path: "/es/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___id",
    path: "/id/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___ja",
    path: "/ja/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___ko",
    path: "/ko/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___ms",
    path: "/ms/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___pt",
    path: "/pt/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___ru",
    path: "/ru/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___uk",
    path: "/uk/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___zh-CN",
    path: "/zh-CN/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___zh-TW",
    path: "/zh-TW/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "tv-help___en-US",
    path: "/en-US/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___es",
    path: "/es/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___id",
    path: "/id/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___ja",
    path: "/ja/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___ko",
    path: "/ko/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___ms",
    path: "/ms/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___pt",
    path: "/pt/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___ru",
    path: "/ru/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___uk",
    path: "/uk/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___zh-CN",
    path: "/zh-CN/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___zh-TW",
    path: "/zh-TW/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv___en-US",
    path: "/en-US/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___es",
    path: "/es/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___id",
    path: "/id/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___ja",
    path: "/ja/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___ko",
    path: "/ko/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___ms",
    path: "/ms/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___pt",
    path: "/pt/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___ru",
    path: "/ru/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___uk",
    path: "/uk/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___zh-CN",
    path: "/zh-CN/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___zh-TW",
    path: "/zh-TW/tv",
    meta: tv80s8GJMkwnMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "unsubscribe___en-US",
    path: "/en-US/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___es",
    path: "/es/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___id",
    path: "/id/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___ja",
    path: "/ja/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___ko",
    path: "/ko/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___ms",
    path: "/ms/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___pt",
    path: "/pt/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___ru",
    path: "/ru/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___uk",
    path: "/uk/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___zh-CN",
    path: "/zh-CN/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___zh-TW",
    path: "/zh-TW/unsubscribe",
    meta: unsubscribeuH6r0XUkMkMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubnO9MU04yTU
  }
]